export class ViewClass {
  //user
  static LITIGATION_SERVICES_PREFIX = 'litigationServices:';
  static AMO_SERVICES_PREFIX = 'amoServices:';

  static GET_USER_PROFILE = this.LITIGATION_SERVICES_PREFIX + '_getUserProfile';
  static CHECK_AUTHORIZED =
    this.AMO_SERVICES_PREFIX + '_checkAuthorizedActionForUserOnPlatform';

  static GET_DEACTIVATED_SERVICES_FOR_USER =
    this.AMO_SERVICES_PREFIX + '_getDeactivatedServicesForUser';
}
